import { Component, OnInit } from '@angular/core';
import { InvoiceTableComponent } from '../invoice-table/invoice-table.component';
import { InvoiceTableFilterComponent } from '../invoice-table-filter/invoice-table-filter.component';

@Component({
    selector: 'app-invoices-page',
    templateUrl: './invoices-page.component.html',
    styleUrls: ['./invoices-page.component.scss'],
    imports: [InvoiceTableFilterComponent, InvoiceTableComponent]
})
export class InvoicesPageComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
